import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/teamcompare";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import {
  getPlayerStats,
  getTeamStats,
  getTeamStatsForSD,
} from "../../../../shared/utils/opta/statsHandler";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import { getDynamicLogoPath, toIsoDateString } from "../../../../shared/utils/functions";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetSD";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const { t } = useTranslation();

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);

  const statsType = getContentById("statsType", fields);

  // const nextGame = _.get(dynamic, "nextGame");
  const matchInfo = _.get(dynamic, "matchInfo");
  const teamCompare = _.get(dynamic, "teamCompare");
  
  
  // const teamDataStyles = _.get(teamData, "styles", {});
  const competitionId = matchInfo?.competition?.id

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];


  const homeStats = _.get(teamCompare, "home");
  const awayStats = _.get(teamCompare, "away");
  const betterSide = _.get(teamCompare, "betterTeam");
  const timeSpan = _.get(teamCompare, "timeSpan");
  
  const statsMappingHome = getTeamStatsForSD(homeStats, statsType, awayStats);
  const statsMappingAway = getTeamStatsForSD(awayStats, statsType, homeStats);
  
  const betterTeam = betterSide === 'home' ? homeTeam : awayTeam;
  const loseTeam = betterSide === 'home' ? awayTeam : homeTeam;
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className={"wc-bg-content"}></div>

          <div className={"dfb-tv-logo"}>
            <img src={assets.sd_dfb_tv_logo} />
          </div>

          <MatchScoreWidget
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            matchInfo={matchInfo}
          />

          <div className={"main-header"}>
            {t("Team Compare Live", { keyPrefix: "templates" })}
            {/* {statsType + " " +  t("Live") } */}
            {/* Offensivaktionen */}
          </div>

          <div className={"versus-info"}>
          </div>

          <div className={"teams-block"}>
            <div className={"team-logo-container home"}>
              <Image
                className="team-logo"
                src={getDynamicLogoPath({ team: homeTeam, competitionId })}
              />
              <div className={"team-name home"}>
                {t(homeTeam?.name, { ns: "countries" })}
              </div>
            </div>
            <div className={"team-logo-container away"}>
              <Image
                className="team-logo"
                src={getDynamicLogoPath({ team: awayTeam, competitionId })}
              />
              <div className={"team-name away"}>
                {t(awayTeam?.name, { ns: "countries" })}
              </div>
            </div>
          </div>

          <div className={"team-stats"}>
            {statsMappingHome.map((statRowHome, index) => {
              const statRowAway = statsMappingAway?.[index];
              return (
                <div key={statRowHome.type} className={"stat-row"}>
                  <div className={"stat-home"}>{statRowHome?.value || "0"}</div>
                  <div className={"stat-label"}>
                    {t(statRowHome?.type, { keyPrefix: "stats" })}
                  </div>
                  <div className={"stat-away"}>{statRowAway?.value || "0"}</div>
                </div>
              );
            })}
          </div>
          <div className="headline-summary">{timeSpan}</div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
